import imageStreamUtil from '@/components/layout/imageStream/js/util'
import * as storage from '@/modules/auth/storage'
import { infraMixin } from '@/modules/infra/mixins'
import infra from '@/util/infra'
import util from '@/util'
import constants from '@/util/constants'
import { obterImagem, obterIcone } from '@/util/imagem'
import mensagens from '@/util/mensagens'
import { BSpinner, BToast } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import cookieUtil from '@/util/cookieUtil'
import { encerrarChat } from '@/components/global/SuporteOnline'

export default {
  name: 'Login',
  components: {
    'b-spinner': BSpinner,
    'b-toast': BToast
  },
  mixins: [infraMixin],
  data: () => ({
    dadosFormulario: {
      escritorio: '',
      usuario: '',
      senha: ''
    },
    flags: {
      efetuandoLogin: false,
      escritorioNaoLogado: false,
      telaPronta: false,
      senhaAntigaSolicitada: false
    },
    modoAutenticacao: {
      modo: null,
      senhaDisponivel: true,
      ssoDisponivel: false,
      migracaoDisponivel: false
    },
    temLogoClienteNaSessao: false,
    erroValidacaoCampos: {},
    mensagemAlerta: '',
    callbackAposLoginSucesso: null
  }),

  computed: {
    ...mapState('auth', ['escritorio', 'logoCliente', 'nomeUsuarioLogado', 'emailUsuario', 'idUsuarioLogado', 'dataCriacaoUsuarioLogado']),
    mostrarBotaoOutroEscritorio () {
      const temEscritorioLogado = !this.flags.escritorioNaoLogado
      return temEscritorioLogado
    },
    obterLogo () {
      return obterImagem('logo-office300.png')
    },
    iconePreambulo () {
      return obterIcone('icone-preambulo.png')
    },
    tituloBotaoSso () {
      if (this.modoAutenticacao.ssoDisponivel) {
        return null
      }
      const escritorio = this.dadosFormulario.escritorio
      const escritorioInformado = !util.valorVazio(escritorio) && !util.valorVazio(escritorio.trim())
      return escritorioInformado ? 'Escritório não habilitado para SSO' : 'Informe o Escritório'
    },
    camposAcessoPreenchidos () {
      const { escritorio, usuario, senha } = this.dadosFormulario
      const campos = this.exibirCampoSenha ? [escritorio, usuario, senha] : [escritorio, usuario]
      return campos.every((campo) => !util.valorVazio(campo) && !util.valorVazio(campo.trim()))
    },
    camposSenhaBloqueados () {
      return this.modoAutenticacao.ssoDisponivel && !this.modoAutenticacao.migracaoDisponivel
    },
    entradaEmDuasEtapas () {
      return this.modoAutenticacao.ssoDisponivel && this.modoAutenticacao.migracaoDisponivel
    },
    exibirCampoSenha () {
      return !this.entradaEmDuasEtapas || this.flags.senhaAntigaSolicitada
    }
  },

  watch: {
    'modoAutenticacao.ssoDisponivel' (ssoDisponivel) {
      this.flags.senhaAntigaSolicitada = false
      if (ssoDisponivel) {
        if (!this.modoAutenticacao.migracaoDisponivel) {
          this.dadosFormulario.usuario = ''
        }
        this.dadosFormulario.senha = ''
        this.erroValidacaoCampos = {}
      }
    },
    'dadosFormulario.usuario' () {
      if (this.flags.senhaAntigaSolicitada) {
        this.flags.senhaAntigaSolicitada = false
        this.dadosFormulario.senha = ''
      }
    }
  },

  async mounted () {
    await encerrarChat(this)
    if (!infra.estaEmModoDev()) {
      this.redirecionarSeNaoEstiverNaRotaDefault(constants.nomeRotaLogin)
    }
    this.ActionSetLogoCliente('')
    await this.verificarEscritorioLogado()
    this.flags.telaPronta = true
  },

  methods: {
    ...mapActions('auth', [
      'ActionSetLoginStrategy',
      'ActionSignOut',
      'ActionSetLogoCliente',
      'ActionSetEscritorio',
      'ActionSetTipoDeAcesso',
      'ActionSetPerfilUsuario',
      'ActionSetAcessoFinanceiro',
      'ActionSetAcessoRelatorios',
      'ActionSetRelatoriosContratado',
      'ActionSetAcessoFaturamento',
      'ActionSetNomeUsuarioLogado',
      'ActionSetAcessoEscritorio',
      'ActionSetFinanceiroContratado',
      'ActionSetFaturamentoContratado',
      'ActionSetCodigoFotoUsuario',
      'ActionSetEscritorioInadimplente',
      'ActionSetIdUsuarioLogado',
      'ActionSetDataCriacaoUsuarioLogado',
      'ActionSetEmailUsuario',
      'ActionSetSuporteOnlineHabilitado',
      'ActionSetIdEmpresa',
      'ActionSetCpfCnpj',
      'ActionSetRepresentanteLegal',
      'ActionSetRegrasLogin',
      'ActionSetDadosAlertaVencimento',
      'ActionSetDadosAlertaDesbloqueioEscritorio',
      'ActionSetOcultarOpcaoMenuBanco',
      'ActionSetAlertaStatusEmpresa'
    ]),
    ...mapGetters('auth', ['temEscritorio', 'temLogoCliente']),

    async verificarEscritorioLogado () {
      const escritorioUrl = this.$route.params.escritorio
      const temEscritorioNaUrl = !util.valorVazio(escritorioUrl)
      if (temEscritorioNaUrl) {
        this.definirEscritorioPelaURL(escritorioUrl)
      }
      const usuarioVeioDaUrl = this.preencherUsuarioPelaURL()
      this.flags.escritorioNaoLogado = !this.temEscritorio()
      if (this.temEscritorio()) {
        this.dadosFormulario.escritorio = this.escritorio
        await this.definirLogotipoPeloEscritorio(this.escritorio)
        await this.consultarModoAutenticacao(this.escritorio)
        if (usuarioVeioDaUrl && this.entradaEmDuasEtapas) {
          await this.autenticar()
        }
      }
    },

    /**
     * Preenche o campo usuário com o valor do parâmetro user da URL, usado na volta do cadastro do SSO.
     *
     * @returns {boolean} true quando o usuário veio da URL e foi preenchido
     *
     * Regras: só aceita texto; o parâmetro é retirado da barra de endereço logo depois de lido, para o
     * e-mail não ficar no histórico do navegador. O escritório continua vindo do caminho da URL. Quem chama
     * só dispara o login sozinho em escritório com SSO e migração, e uma única vez por abertura da tela.
     */
    preencherUsuarioPelaURL () {
      const usuarioUrl = this.$route.query.user
      if (typeof usuarioUrl !== 'string' || util.valorVazio(usuarioUrl.trim())) {
        return false
      }
      this.dadosFormulario.usuario = usuarioUrl.trim()
      this.$router.replace({ name: this.$route.name, params: this.$route.params }).catch(() => {})
      return true
    },

    definirModoAutenticacaoPadrao () {
      this.modoAutenticacao = {
        modo: constants.modoAutenticacaoSso.legado,
        senhaDisponivel: true,
        ssoDisponivel: false,
        migracaoDisponivel: false
      }
    },

    async consultarModoAutenticacao (escritorio) {
      const escritorioTratado = util.valorVazio(escritorio) ? '' : escritorio.trim()
      if (util.valorVazio(escritorioTratado)) {
        this.definirModoAutenticacaoPadrao()
        return
      }

      try {
        const resposta = await this.axios.get('/sso/escritorio/' + encodeURIComponent(escritorioTratado) + '/modo')
        const dadosModo = resposta.data.retorno
        this.modoAutenticacao = {
          modo: dadosModo.modo,
          senhaDisponivel: dadosModo.senha_disponivel,
          ssoDisponivel: dadosModo.sso_disponivel,
          migracaoDisponivel: dadosModo.migracao_disponivel === true
        }
      } catch (e) {
        this.definirModoAutenticacaoPadrao()
      }
    },

    definirEscritorioPelaURL (escritorioUrl) {
      this.ActionSetEscritorio(escritorioUrl)
    },

    async definirLogotipoPeloEscritorio (escritorio) {
      try {
        const resposta = await this.axios.get('/escritorio/' + escritorio + '/logotipo')
        const dadosRespostaRequisicao = resposta.data.retorno
        if (dadosRespostaRequisicao.success === true) {
          this.ActionSetLogoCliente(dadosRespostaRequisicao.f_client_logo)
          this.temLogoClienteNaSessao = this.temLogoCliente()
        } else {
          this.acessarComOutroEscritorio()
        }
      } catch (e) {
        this.acessarComOutroEscritorio()
      }
    },

    eventoLoginTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter && this.camposAcessoPreenchidos) {
        this.autenticar()
      }
    },

    async eventoEscritorioTeclaEnter (evento) {
      if (evento.keyCode === constants.teclado.enter) {
        clearTimeout(this.timeoutValidacaoModoAutenticacao)
        await this.consultarModoAutenticacao(this.dadosFormulario.escritorio)
        if (!this.modoAutenticacao.ssoDisponivel) {
          this.autenticar()
        }
        return
      }
      this.definirModoAutenticacaoPadrao()
      this.agendarValidacaoModoAutenticacao()
    },

    agendarValidacaoModoAutenticacao () {
      clearTimeout(this.timeoutValidacaoModoAutenticacao)
      const escritorioDigitado = this.dadosFormulario.escritorio
      this.timeoutValidacaoModoAutenticacao = setTimeout(() => {
        this.consultarModoAutenticacao(escritorioDigitado)
      }, constants.tempoParaAguardarDigitacaoNoCombo)
    },

    async eventoSairDoCampoEscritorio () {
      clearTimeout(this.timeoutValidacaoModoAutenticacao)
      await this.consultarModoAutenticacao(this.dadosFormulario.escritorio)
    },

    async autenticar () {
      if (this.flags.efetuandoLogin !== true) {
        this.callbackAposLoginSucesso = null
        this.mensagemAlerta = ''
        const validacaoSucesso = this.validarDadosFormulario()
        if (validacaoSucesso) {
          await this.efetuarLogin()
        }
      }
    },

    validarDadosFormulario () {
      this.erroValidacaoCampos = {}
      const dados = {
        escritorio: this.dadosFormulario.escritorio,
        usuario: this.dadosFormulario.usuario
      }
      if (this.exibirCampoSenha) {
        dados.senha = this.dadosFormulario.senha
      }
      let validacaoSucesso = true

      for (let indice in dados) {
        let campo = dados[indice].trim()
        if (util.valorVazio(campo)) {
          this.erroValidacaoCampos[indice] = 'Este campo é obrigatório'
          validacaoSucesso = false
        }
      }

      return validacaoSucesso
    },

    async efetuarLogin () {
      this.flags.efetuandoLogin = true
      const dadosLogin = await this.enviarRequisicaoLogin()

      const loginSucesso = this.validarLogin(dadosLogin)
      if (loginSucesso) {
        this.ActionSignOut()
        await this.definirDadosDeAcesso(dadosLogin)
        await this.encaminharParaTelainicial(dadosLogin)
      } else {
        this.flags.efetuandoLogin = false
      }
    },

    async enviarRequisicaoLogin () {
      let dadosRespostaRequisicao = null
      try {
        await cookieUtil.gerarCookieTokenCsrf()
        const resposta = await this.axios.post('/login', {
          'user': this.dadosFormulario.usuario,
          'password': this.exibirCampoSenha ? this.dadosFormulario.senha : '',
          'tenant': this.dadosFormulario.escritorio
        })
        dadosRespostaRequisicao = resposta.data
      } catch (e) {
        const limiteExcedido = e.response && e.response.status === 429
        this.mensagemAlerta = limiteExcedido ? e.response.data.message : mensagens.falhaComunicacaoServidor
      }
      return dadosRespostaRequisicao
    },

    irParaCadastroSso (url) {
      // login e senha antigos não ficam na tela depois da ida ao SSO, e a URL assinada não é guardada
      this.dadosFormulario.usuario = ''
      this.dadosFormulario.senha = ''
      window.location.assign(url)
    },

    irParaProvedorSso (url) {
      // o escritório precisa sobreviver à navegação de página inteira até o hub e de volta
      storage.setEscritorio(this.dadosFormulario.escritorio.trim())
      window.location.href = url
    },

    async entrarComProvedorSso () {
      if (this.flags.efetuandoLogin) {
        return
      }
      this.mensagemAlerta = ''
      this.flags.efetuandoLogin = true
      try {
        await cookieUtil.gerarCookieTokenCsrf()
        const resposta = await this.axios.post('/sso/login/iniciar', {
          tenant: this.dadosFormulario.escritorio,
          user: this.dadosFormulario.usuario
        })
        const dadosResposta = resposta.data
        if (dadosResposta.success && !util.valorVazio(dadosResposta.sso_url_autorizacao)) {
          this.irParaProvedorSso(dadosResposta.sso_url_autorizacao)
          return
        }
        this.mensagemAlerta = dadosResposta.message || mensagens.ssoEntradaIndisponivel
      } catch (e) {
        this.mensagemAlerta = mensagens.falhaComunicacaoServidor
      }
      this.flags.efetuandoLogin = false
    },

    validarLogin (dadosLogin) {
      if (util.valorEhNulo(dadosLogin)) {
        return false
      }

      if (!util.valorVazio(dadosLogin.sso_migracao_url)) {
        this.irParaCadastroSso(dadosLogin.sso_migracao_url)
        return false
      }

      if (dadosLogin.sso_senha_necessaria) {
        this.flags.senhaAntigaSolicitada = true
        this.dadosFormulario.senha = ''
        this.mensagemAlerta = dadosLogin.message || mensagens.ssoSenhaAntigaNecessaria
        return false
      }

      if (dadosLogin.sso_redirecionar) {
        this.irParaProvedorSso(dadosLogin.sso_url_autorizacao)
        return false
      }

      if (dadosLogin.two_factor_required) {
        this.registrarPendencia2fa(dadosLogin)

        this.$router.push({ name: 'validacao-2fa-office' })
        return false
      }

      if (dadosLogin.login_rules) {
        this.registrarPendenciasLogin(dadosLogin)
      }

      const loginSucesso = dadosLogin.success

      if (!loginSucesso) {
        this.mensagemAlerta = dadosLogin.message
      }

      return loginSucesso
    },

    registrarPendencia2fa (dadosLogin) {
      this.ActionSetLoginStrategy(dadosLogin.login_strategy)

      const pendenciasLogin = {
        deveValidar2fa: true,
        userId: dadosLogin.user_id,
        tempoExpiracao: dadosLogin.two_factor_expires_in || 30,
        tenant: this.dadosFormulario.escritorio
      }

      this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))
    },

    registrarPendenciasLogin (dadosLogin) {
      this.ActionSetLoginStrategy(dadosLogin.login_strategy)

      const pendenciasLogin = dadosLogin.login_rules

      this.ActionSetRegrasLogin(JSON.stringify(pendenciasLogin))
    },

    async definirDadosDeAcesso (dadosLogin) {
      const escritorio = this.dadosFormulario.escritorio.trim()
      this.ActionSetLoginStrategy(dadosLogin.login_strategy)
      this.ActionSetLogoCliente(dadosLogin.f_client_logo)
      this.ActionSetEscritorio(escritorio)
      this.ActionSetTipoDeAcesso(dadosLogin.f_role)
      this.ActionSetPerfilUsuario(dadosLogin.f_profile)
      this.ActionSetAcessoFaturamento(dadosLogin.f_billing)
      this.ActionSetAcessoEscritorio(dadosLogin.f_office)
      this.ActionSetFaturamentoContratado(dadosLogin.f_billing_contract)
      this.ActionSetAcessoFinanceiro(dadosLogin.f_financial)
      this.ActionSetAcessoRelatorios(dadosLogin.f_reports)
      this.ActionSetRelatoriosContratado(dadosLogin.f_reports_contract)
      this.ActionSetFinanceiroContratado(dadosLogin.f_financial_contract)
      this.ActionSetNomeUsuarioLogado(dadosLogin.f_user_name)
      this.ActionSetEmailUsuario(dadosLogin.user_mail)
      this.ActionSetIdUsuarioLogado(dadosLogin.user_id)
      this.ActionSetDataCriacaoUsuarioLogado(dadosLogin.user_create_date)
      const codigoFotoUsuario = await this.obterCodigoFotoUsuario(dadosLogin.f_photo)
      this.ActionSetCodigoFotoUsuario(codigoFotoUsuario)
      this.ActionSetEscritorioInadimplente(dadosLogin.escritorioInadimplente)
      this.ActionSetAlertaStatusEmpresa(dadosLogin.alertaStatusEmpresa ?? null)
      this.ActionSetSuporteOnlineHabilitado(dadosLogin.onlineSupportEnabled)
      this.ActionSetIdEmpresa(dadosLogin.office_id)
      this.ActionSetOcultarOpcaoMenuBanco(dadosLogin.hideBankMenu)
    },

    async obterCodigoFotoUsuario (streamFotoUsuario) {
      let codigoFotoUsuario = null
      try {
        codigoFotoUsuario = await imageStreamUtil.obterCodigoBase64DoObjetoStream(streamFotoUsuario)
      } catch (e) {
        this.callbackAposLoginSucesso = () => {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaAoObterAvatarUsuario)
        }
      }
      return codigoFotoUsuario
    },

    async encaminharParaTelainicial (dadosLogin) {
      const listaPerfisAcessoDiretoJuridico = this.obterListaPerfisAcessoDiretoJuridico()
      const perfilUsuario = dadosLogin.f_profile.toString()
      const perfilPodeAcessarDiretoJuridico = (listaPerfisAcessoDiretoJuridico.indexOf(perfilUsuario) !== -1)
      const loginNaoRealizado = dadosLogin.f_status === constants.statusUsuario.loginNaoRealizado
      const deveAlterarSenha = dadosLogin.login_rules && dadosLogin.login_rules.deveAlterarSenha === true

      let rotaInicial = 'inicio'

      if (loginNaoRealizado) {
        rotaInicial = 'primeiroAcesso'
      } else if (deveAlterarSenha) {
        rotaInicial = 'alteracao-senha-office'
      }

      if (rotaInicial === 'inicio' && perfilPodeAcessarDiretoJuridico) {
        await this.redirecionarParaSistemaExterno(constants.urlSistemaExterno.juridico, false)
        this.ActionSignOut()
      } else {
        this.redirecionarParaManager(rotaInicial, () => {
          if (this.callbackAposLoginSucesso !== null) {
            this.callbackAposLoginSucesso()
          }
        })
      }
    },

    acessarComOutroEscritorio () {
      this.flags.escritorioNaoLogado = true
      this.dadosFormulario.escritorio = ''
      this.temLogoClienteNaSessao = false
      this.erroValidacaoCampos = {}
      this.ActionSetLogoCliente('')
      this.ActionSetEscritorio('')
      storage.deleteLogoCliente()
      storage.deleteEscritorio()
      this.definirModoAutenticacaoPadrao()
    }
  }
}
